const packages = [

{
id:1,
name:"Goa Beach Holiday",
destination:"Goa, India",
price:12000,
original_price:15000,
category:"domestic",
duration:"4D / 3N",
image:"https://images.unsplash.com/photo-1512343879784-a960bf40e7f2",
highlights:["Beach","Water Sports","Nightlife"]
},

{
id:2,
name:"Kashmir Paradise",
destination:"Srinagar, Kashmir",
price:25000,
original_price:30000,
category:"domestic",
duration:"6D / 5N",
image:"https://images.unsplash.com/photo-1501785888041-af3ef285b470",
highlights:["Snow Mountains","Shikara Ride","Gulmarg"]
},

{
id:3,
name:"Kerala Backwaters",
destination:"Alleppey, Kerala",
price:18000,
original_price:22000,
category:"domestic",
duration:"5D / 4N",
image:"https://images.unsplash.com/photo-1593693411515-c20261bcad6e",
highlights:["Houseboat","Backwaters","Nature"]
},

{
id:4,
name:"Rajasthan Royal Tour",
destination:"Jaipur, Udaipur, Jodhpur",
price:22000,
original_price:26000,
category:"domestic",
duration:"6D / 5N",
image:"https://images.unsplash.com/photo-1599661046827-dacff0c0f09e",
highlights:["Forts","Palaces","Desert Safari"]
},

{
id:5,
name:"Manali Snow Adventure",
destination:"Manali, Himachal",
price:16000,
original_price:20000,
category:"domestic",
duration:"5D / 4N",
image:"https://images.unsplash.com/photo-1605540436563-5bca919ae766",
highlights:["Snow","Adventure Sports","Mountains"]
},

{
id:6,
name:"Andaman Island Escape",
destination:"Andaman Islands",
price:28000,
original_price:33000,
category:"domestic",
duration:"5D / 4N",
image:"https://images.unsplash.com/photo-1589308078059-be1415eab4c3",
highlights:["Scuba Diving","Islands","Coral Reefs"]
},

{
id:7,
name:"Leh Ladakh Road Trip",
destination:"Leh, Ladakh",
price:30000,
original_price:36000,
category:"domestic",
duration:"7D / 6N",
image:"https://images.unsplash.com/photo-1593693397690-362cb9666fc2",
highlights:["Bike Trip","Mountains","Lakes"]
},

{
id:8,
name:"Darjeeling Tea Hills",
destination:"Darjeeling",
price:14000,
original_price:18000,
category:"domestic",
duration:"4D / 3N",
image:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
highlights:["Tea Gardens","Toy Train","Hills"]
},

{
id:9,
name:"Dubai Luxury Tour",
destination:"Dubai, UAE",
price:55000,
original_price:65000,
category:"international",
duration:"5D / 4N",
image:"https://images.unsplash.com/photo-1518684079-3c830dcef090",
highlights:["Burj Khalifa","Desert Safari","Luxury Hotels"]
},

{
id:10,
name:"Bali Island Paradise",
destination:"Bali, Indonesia",
price:48000,
original_price:56000,
category:"international",
duration:"6D / 5N",
image:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
highlights:["Beaches","Temples","Waterfalls"]
},

{
id:11,
name:"Thailand Beach Escape",
destination:"Phuket, Thailand",
price:42000,
original_price:50000,
category:"international",
duration:"5D / 4N",
image:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
highlights:["Beach","Island Tour","Nightlife"]
},

{
id:12,
name:"Maldives Honeymoon",
destination:"Maldives",
price:90000,
original_price:110000,
category:"international",
duration:"4D / 3N",
image:"https://images.unsplash.com/photo-1573843981267-be1999ff37cd",
highlights:["Water Villas","Snorkeling","Romantic"]
},

{
id:13,
name:"Singapore City Tour",
destination:"Singapore",
price:52000,
original_price:62000,
category:"international",
duration:"5D / 4N",
image:"https://images.unsplash.com/photo-1525625293386-3f8f99389edd",
highlights:["Universal Studios","Marina Bay","City Tour"]
},

{
id:14,
name:"Malaysia Adventure",
destination:"Kuala Lumpur",
price:45000,
original_price:52000,
category:"international",
duration:"5D / 4N",
image:"https://images.unsplash.com/photo-1508964942454-1a56651d54ac",
highlights:["Petronas Towers","City Tour","Shopping"]
},

{
id:15,
name:"Paris Romantic Escape",
destination:"Paris, France",
price:95000,
original_price:110000,
category:"international",
duration:"6D / 5N",
image:"https://images.unsplash.com/photo-1502602898657-3e91760cbb34",
highlights:["Eiffel Tower","City Tour","Museums"]
},

{
id:16,
name:"Swiss Alps Experience",
destination:"Switzerland",
price:120000,
original_price:140000,
category:"international",
duration:"7D / 6N",
image:"https://images.unsplash.com/photo-1501785888041-af3ef285b470",
highlights:["Alps","Snow","Train Journey"]
},

{
id:17,
name:"Turkey Cultural Tour",
destination:"Istanbul, Turkey",
price:70000,
original_price:82000,
category:"international",
duration:"6D / 5N",
image:"https://images.unsplash.com/photo-1541410965313-d53b3c16ef17",
highlights:["Mosques","Bazaars","Culture"]
},

{
id:18,
name:"Japan Cherry Blossom Tour",
destination:"Tokyo, Japan",
price:130000,
original_price:150000,
category:"international",
duration:"7D / 6N",
image:"https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e",
highlights:["Cherry Blossoms","Temples","Technology"]
},

{
id:19,
name:"New York City Lights",
destination:"New York, USA",
price:110000,
original_price:130000,
category:"international",
duration:"6D / 5N",
image:"https://images.unsplash.com/photo-1496588152823-e89c7a0b38f3",
highlights:["Statue of Liberty","Times Square","City Tour"]
},

{
id:20,
name:"Australia Coastal Journey",
destination:"Sydney, Australia",
price:140000,
original_price:165000,
category:"international",
duration:"7D / 6N",
image:"https://images.unsplash.com/photo-1506976785307-8732e854ad03",
highlights:["Opera House","Beaches","Wildlife"]
}

];

export default packages;
